import { Action, createReducer, on } from "@ngrx/store";
import { IResponseMonitoringDetail, IResponseOperationMonitoring } from "../../interfaces/monitoring";
import { IMonitoringState } from "./monitoring";
import { RESET_MONITORING_STORE, RETRIVE_DETAIL_MONITORING_OPERATION_SUCCESS, RETRIVE_MONITORING_OPERATION_SUCCESS } from "./monitoring.actions";

const initialState: IMonitoringState = {
    operationMonitoring: null,
    operationMonitoringDetail: null
  };

  const handleOperationMonitoring = (
    state: IMonitoringState,
    { operationMonitoring }: { operationMonitoring: IResponseOperationMonitoring | null }
  ): IMonitoringState => {
    return {
      ...state,
      operationMonitoring
    };
  };

  const handleOperationMonitoringDetail = (
    state: IMonitoringState,
    { operationMonitoringDetail }: { operationMonitoringDetail: IResponseMonitoringDetail | null }
  ): IMonitoringState => {
    return {
      ...state,
      operationMonitoringDetail
    };
  };

  const handleResetMonitoringStore = (): IMonitoringState => {
    return {
      operationMonitoring: null,
      operationMonitoringDetail: null
    };
  };

  export const reducer = createReducer(
    initialState,
    on(RETRIVE_MONITORING_OPERATION_SUCCESS, handleOperationMonitoring),
    on(RETRIVE_DETAIL_MONITORING_OPERATION_SUCCESS, handleOperationMonitoringDetail),
    on(RESET_MONITORING_STORE, handleResetMonitoringStore)
  );
  
  export const monitoringReducer = (
    state: IMonitoringState | undefined,
    action: Action
  ): IMonitoringState => reducer(state, action);
  